import axios from '@/axios/index'

// 查看所有用户
export function getList(data) {
  return axios({
    url: '/api/backstage/user/list/search',
    // url: '/api/backstage/user/list',
    method: 'post',
    data
  })
}

// 查询用户
export function searchUserList(data) {
  return axios({
    url: '/api/backstage/user/list/search',
    method: 'post',
    data
  })
}

// 通过id查询用户
export function getDetailInfo(data) {
  return axios({
    url: '/api/backstage/user/search',
    method: 'post',
    data
  })
}

// 检测用户名称
export function checkAccount(data) {
  return axios({
    url: '/api/backstage/user/account/check',
    method: 'post',
    data
  })
}

// 添加用户
export function addUser(data) {
  return axios({
    url: '/api/backstage/user/add',
    method: 'post',
    data
  })
}

// 修改用户
export function updateUser(data) {
  return axios({
    url: '/api/backstage/user/update',
    method: 'post',
    data
  })
}

// 修改用户密码
export function updatePassword(data) {
  return axios({
    url: '/api/backstage/user/password/update',
    method: 'post',
    data
  })
}
